import React, {PureComponent} from "react"
import {BeaconRenderProps} from "react-joyride"

import {BeaconOuter, BeaconInner} from "./styled"

interface Props extends BeaconRenderProps {}
interface State {
  showBeacon: boolean
}

const HIDE_AFTER_MS = 10000

class CustomBeacon extends PureComponent<Props, State> {
  private timerHandler: any

  state: State = {
    showBeacon: true
  }

  componentDidMount = () => {
    this.timerHandler = setTimeout(() => {
      this.setState({showBeacon: false})
    }, HIDE_AFTER_MS)
  }
  componentWillUnmount = () => {
    if (this.timerHandler) clearTimeout(this.timerHandler)
  }

  render() {
    const {onClick, onMouseEnter} = this.props
    const {showBeacon} = this.state

    return showBeacon ? (
      <BeaconOuter {...this.props} onMouseEnter={onMouseEnter} onClick={onClick}>
        <BeaconInner />
      </BeaconOuter>
    ) : (
      <span />
    )
  }
}

export default CustomBeacon
